function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
  fill: "#80BCC8",
  fillOpacity: ".25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 10l6 6-6 6-1.4-1.4 4.575-4.6-4.575-4.6L17 10zm-6.6 0l6 6-6 6L9 20.6l4.575-4.6L9 11.4l1.4-1.4z",
  fill: "#007892"
})));